import React from 'react';
import Logo from '../Assets/Image/logo-loyalty-big.png';
import {
  MdBarChart,
  MdDataThresholding,
  MdSearch,
  MdSecurityUpdateGood,
} from 'react-icons/md';

export const Features = () => {
  const features = [
    {
      id: 1,
      icon: <MdSearch />,
      title: 'No Hidden Fees',
      description:
        'Our rates and charges are the most competitive in the market.',
    },
    {
      id: 2,
      icon: <MdSecurityUpdateGood />,
      title: 'Secure Trusted',
      description:
        'Every transaction is secured with state of the art encryption',
    },
  ];
  const featurestwo = [
    {
      id: 1,
      icon: <MdDataThresholding />,
      title: 'Fast Transaction Processing',
      description:
        'Swift transaction processing for seamless financial operations, ensuring reliable and timely transactions.',
    },
    {
      id: 2,
      icon: <MdBarChart />,
      title: 'Global Coverage',
      description:
        'Gain worldwide access with our extensive global coverage, ensuring comprehensive support wherever your business ventures take you.',
    },
  ];

  return (
    <section>
      <div className='px-4 sm:px-10 md:px-20 mx-auto gap-12 max-w-[1440px] flex flex-col'>
        <div className='space-y-2'>
          <h3 className='text-b-mc '>FEATURES</h3>
          <h2 className='text-2xl font-semibold'>Why Choose Us</h2>
        </div>
        <div className='gap-11 w-full grid md:grid-cols-2 lg:grid-cols-3 items-center '>
          <div className='flex flex-col gap-12 col-span-1'>
            {features.map((data) => (
              <div
                key={data.id}
                className='flex flex-col lg:items-end lg:text-right'
              >
                <span className='text-4xl text-b-mc '>{data.icon}</span>
                <div>
                  <h1 className='font-semibold text-xl'>{data.title}</h1>
                  <p>{data.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className='col-span-1 hidden lg:block '>
            <img
              src={Logo}
              alt='img'
              className='mx-auto object-contain object-center w-3/5'
            />
          </div>
          <div className='flex flex-col gap-12'>
            {featurestwo.map((data) => (
              <div key={data.id} className=''>
                <span className='text-4xl text-b-mc '>{data.icon}</span>
                <div>
                  <h1 className='font-semibold text-xl'>{data.title}</h1>
                  <p>{data.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
